/* --- Misspolly: botao de wishlist na mesma linha do Add to cart.
 Roda antes da camada de wishlist de proposito: assim, quando o render dela passa por
 todos os [data-wishlist-toggle], este botao ja existe e recebe o estado is-active junto. --- */
(function () {
  'use strict';
  if (window.__misspollyWishlistInline) return;
  window.__misspollyWishlistInline = true;

  var ICONE = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M6 3h12v18l-6-4.2L6 21z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';

  function garantir() {
    var linha = document.querySelector('.product-info__buy-buttons');
    if (!linha) return;
    var origem = document.querySelector('.product-info__block-item[data-block-type="liquid"] .fl-wishlist-btn[data-handle]');
    if (!origem) return;

    var bloco = origem.closest('.product-info__block-item');
    if (bloco) bloco.classList.add('fl-wishlist-block--oculto');

    var handle = origem.getAttribute('data-handle') || '';
    var atual = linha.querySelector('.fl-wishlist-inline');
    if (atual && atual.getAttribute('data-handle') === handle) return;
    if (atual) atual.remove();

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fl-wishlist-inline' + (origem.classList.contains('is-active') ? ' is-active' : '');
    b.setAttribute('data-wishlist-toggle', '');
    b.setAttribute('data-handle', handle);
    var id = origem.getAttribute('data-id');
    if (id) b.setAttribute('data-id', id);
    b.setAttribute('aria-pressed', origem.getAttribute('aria-pressed') || 'false');
    b.setAttribute('aria-label', origem.getAttribute('data-label-off') || 'Add to Wishlist');
    b.innerHTML = ICONE;
    linha.insertBefore(b, linha.firstChild);
    linha.classList.add('fl-buy-row');
  }

  /* 04/10/2026: watches only the product section (was: the whole <body> on every page, collection included,
     where there is no buy button to decorate; 26 callbacks during the collection load). */
  var vigiado = null;
  function ligar() {
    garantir();
    var linha = document.querySelector('.product-info__buy-buttons');
    if (!linha) return;
    var secao = linha.closest('.shopify-section') || document.body;
    if (secao === vigiado) return;
    vigiado = secao;
    var pendente = false;
    new MutationObserver(function () {
      if (pendente) return;
      pendente = true;
      setTimeout(function () { pendente = false; garantir(); }, 120);
    }).observe(secao, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligar);
  else ligar();
  document.addEventListener('shopify:section:load', ligar); // theme editor re-renders the section element itself
})();

/* Misspolly wishlist - theme layer.
 Local-first (localStorage). When the customer is logged in and the header section has an endpoint,
 every change is posted to the backend, which stores it in the customer metafield custom.wishlist
. window.MISSPOLLY_WISHLIST is printed by snippets/misspolly-wishlist-data.liquid.
 Owner rule (03/10/2026, replaces 08/09): visitors save without an account. The list lives in
 localStorage and the visitor stays on the product page; when they log in, the local list is merged into
 the account list and synced. */
(function () {
  var KEY = 'misspolly_wishlist_v1';
  var cfg = window.MISSPOLLY_WISHLIST || {};
  var ICON = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M6 3h12v18l-6-4.2L6 21z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';

  /* The list must not get lost (owner, 04/10/2026): a visitor without an account may come back days later.
     It is kept in three places: localStorage, a first-party cookie (400 days) and an attribute of the Shopify cart
     (kept on Shopify's side; its cookie is set by the server with a 3-month expiry, measured 04/10/2026; Shopify's
     docs say an untouched cart may be dropped after 30 days, so the copy is renewed on a visit once it is a week old).
     iPhone Safari erases what a page writes on the device after 7 days without a visit, so the cart copy is what
     brings the list back there.
     Each save / remove is also sent to the "wishlist-salvo" function (owner's notice + base of most saved products). */
  var CK = 'mp_wl', DK = 'mp_wl_d', ATTR = '_wishlist';
  function ck(n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : null; }
  function setCk(n, v) { try { document.cookie = n + '=' + encodeURIComponent(v) + '; path=/; max-age=34560000; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); } catch (e) {} }
  function pack(l) { return l.slice(0, 40).map(function (i) { return i.handle; }).join(','); }
  function unpack(s) { return String(s || '').split(',').filter(function (h) { return /^[a-z0-9][a-z0-9-]*$/.test(h); }).map(function (h) { return { handle: h, id: null }; }); }
  function read() {
    var raw = null; try { raw = localStorage.getItem(KEY); } catch (e) {}
    if (raw !== null) { try { var l = JSON.parse(raw); if (Array.isArray(l)) return l; } catch (e) {} }
    // nothing on this device (first visit, or the browser cleared it): bring the list back from the cookie, then from the cart
    var c = ck(CK), back = unpack(c !== null ? c : cfg.cart);
    if (back.length) { try { localStorage.setItem(KEY, JSON.stringify(back)); } catch (e) {} }
    return back;
  }
  var cartTimer = null;
  function saveCart() {   // one small request, only after a change (or to renew the 3 months)
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      var v = pack(list), a = {}; a[ATTR] = v;
      try {
        fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: a }) })
          .then(function (r) { if (r.ok) { try { sessionStorage.setItem('mp_wl_c', v); localStorage.setItem('mp_wl_t', String(Date.now())); } catch (e) {} } }).catch(function () {});
      } catch (e) {}
    }, 700);
  }
  function write(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} setCk(CK, pack(l)); saveCart(); }
  function device() {
    var d = null; try { d = localStorage.getItem(DK); } catch (e) {}
    d = d || ck(DK);
    if (!d || !/^[a-z0-9-]{8,64}$/.test(d)) d = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : 'd-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
    try { localStorage.setItem(DK, d); } catch (e) {}
    setCk(DK, d);
    return d;
  }
  function track(action, item) {
    if (window.Shopify && (Shopify.designMode || (Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main'))) return;   // editor / draft preview: not a shopper
    var url = cfg.endpoint ? cfg.endpoint.replace(/\/wishlist\/?$/, '/wishlist-salvo') : '';
    if (!url || url === cfg.endpoint) return;
    var body = JSON.stringify({ shop: cfg.shop, device: device(), action: action, item: item ? { handle: item.handle, id: item.id || null } : null, total: list.length,
      customer_id: cfg.customerId || null, date: cfg.customerId ? cfg.date : null, sig: cfg.customerId ? cfg.sig : null });
    // text/plain: a single request, no CORS preflight; the page does not wait for the answer
    try { if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain;charset=UTF-8' }))) return; } catch (e) {}
    try { fetch(url, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: body }).catch(function () {}); } catch (e) {}
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) { var fmt = cfg.moneyFormat || '${{amount}}'; return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, (cents / 100).toFixed(2)); }

  var loggedIn = !!cfg.customerId;
  var list = read(); if (!Array.isArray(list)) list = [];

  function has(handle) { return list.some(function (i) { return i.handle === handle; }); }

  function post(action, item) {
    if (!cfg.endpoint || !cfg.customerId || !cfg.sig) return;
    try {
      fetch(cfg.endpoint, {
        method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ shop: cfg.shop, customer_id: cfg.customerId, date: cfg.date, sig: cfg.sig, action: action, item: item, items: list })
      }).catch(function () {});
    } catch (e) {}
  }

  // A product removed here in the last 15 minutes must not come back from an older copy of the account list (a page
  // printed before the removal: back button, prefetch, request still on its way).
  var XK = 'mp_wl_x';
  function gone() { var o = {}; try { o = JSON.parse(localStorage.getItem(XK) || '{}') || {}; } catch (e) {} var n = Date.now(), k; for (k in o) if (n - o[k] > 9e5) delete o[k]; return o; }
  function mark(h, on) { var o = gone(); if (on) o[h] = Date.now(); else delete o[h]; try { localStorage.setItem(XK, JSON.stringify(o)); } catch (e) {} }

  // Logged in: merge the account list into the local one, then push the union back.
  if (cfg.customerId && Array.isArray(cfg.items)) {
    var changed = false, removedHere = gone();
    cfg.items.forEach(function (s) { if (s && s.handle && !has(s.handle) && !removedHere[s.handle]) { list.push(s); changed = true; } });
    if (changed) write(list);
    if (list.length !== cfg.items.length) {   // once per session for the same list (a product that left the catalog would ask again on every page)
      var sk = pack(list), was = null; try { was = sessionStorage.getItem('mp_wl_s'); } catch (e) {}
      if (was !== sk) { try { sessionStorage.setItem('mp_wl_s', sk); } catch (e) {} post('sync', null); }
    }
    // she saved as a visitor on this device and has now entered her account: tell the base once per session, so the
    // owner's notice comes with her name and e-mail
    try { if (cfg.sig && (localStorage.getItem(DK) || ck(DK)) && sessionStorage.getItem('mp_wl_link') !== String(cfg.customerId)) { sessionStorage.setItem('mp_wl_link', String(cfg.customerId)); track('link', null); } } catch (e) {}
  }
  // keep the three copies in step: a list that exists here but not in the cookie / cart copy (older visitor, cart
  // finished or expired), or a cart copy older than 7 days (renews its 3 months). Runs off the critical path.
  (function () {
    var v = pack(list); if (!list.length && !cfg.cart) return;
    if (ck(CK) !== v) setCk(CK, v);
    var seen = null, last = 0; try { seen = sessionStorage.getItem('mp_wl_c'); last = Number(localStorage.getItem('mp_wl_t')) || 0; } catch (e) {}
    if ((cfg.cart || '') === v && Date.now() - last < 6048e5) return;
    if (seen === v && cfg.cart && Date.now() - last < 6048e5) return;   // after an order the cart (and its copy) is gone: send again
    (window.requestIdleCallback || function (f) { setTimeout(f, 2500); })(saveCart);
  })();

  function toggle(item) {
    list = read();   // another tab, or this page restored by the back button, may hold an older list
    if (has(item.handle)) { mark(item.handle, true); list = list.filter(function (i) { return i.handle !== item.handle; }); post('remove', item); write(list); track('remove', item); }
    else { mark(item.handle, false); list.unshift(item); post('add', item); write(list); track('add', item); }
    render(); renderPage();
  }
  function refresh() { list = read(); render(); renderPage(); }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) refresh(); });

  function render() {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { var n = String(list.length); if (el.textContent !== n) el.textContent = n; el.hidden = list.length === 0; });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-handle'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = btn.querySelector('[data-wishlist-label]');
      if (lbl) { var txt = on ? (btn.getAttribute('data-label-on') || 'Added to Wishlist') : (btn.getAttribute('data-label-off') || 'Add to Wishlist'); if (lbl.textContent !== txt) lbl.textContent = txt; }
    });
  }

  function decorateCards(root) {
    var added = 0;
    (root || document).querySelectorAll('product-card:not([data-wishlist-ready])').forEach(function (card) {
      card.setAttribute('data-wishlist-ready', '1');
      if (card.querySelector('.fl-wishlist-card')) { added++; return; }   // printed by snippets/product-card.liquid: only paint its state
      var link = card.querySelector('a[href*="/products/"]'); if (!link) return;
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/); if (!m) return;
      var figure = card.querySelector('.product-card__figure') || card;
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'fl-wishlist-card';
      btn.setAttribute('data-wishlist-toggle', ''); btn.setAttribute('data-handle', m[1]); btn.setAttribute('aria-label', 'Add to wishlist');
      btn.innerHTML = ICON;
      figure.appendChild(btn);
      added++;
    });
    if (added) render();
  }

  function cardHTML(p) {
    var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
    var price = money(p.price) + (p.compare_at_price > p.price ? ' <s>' + money(p.compare_at_price) + '</s>' : '');
    return '<div class="fl-wl-card"><div class="fl-wl-card__figure"><a href="/products/' + esc(p.handle) + '"><img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy"></a>' +
      '<button type="button" class="fl-wishlist-card is-active" data-wishlist-toggle data-handle="' + esc(p.handle) + '" data-id="' + p.id + '" aria-label="Remove from wishlist">' + ICON + '</button></div>' +
      '<div class="fl-wl-card__info"><a class="fl-wl-card__title" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a><div class="fl-wl-card__price">' + price + '</div></div></div>';
  }

  var pageToken = 0;
  function renderPage() {
    var grid = document.querySelector('[data-wishlist-grid]'); if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var token = ++pageToken;
    if (!list.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    Promise.all(list.map(function (i) {
      return fetch('/products/' + encodeURIComponent(i.handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      if (token !== pageToken) return;
      var ok = products.filter(Boolean);
      grid.innerHTML = ok.map(cardHTML).join('');
      if (empty) empty.hidden = ok.length > 0;   // every saved product left the catalogue: show the empty state, not a blank page
      render();
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]'); if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var id = btn.getAttribute('data-id');
    toggle({ handle: btn.getAttribute('data-handle'), id: id ? Number(id) : null });
  }, true);

  function init() {
    decorateCards(); render(); renderPage();
    var pending = false;
    new MutationObserver(function (muts) {
      if (pending) return;
      var relevant = muts.some(function (m) { return m.addedNodes && m.addedNodes.length; });
      if (!relevant) return;
      pending = true;
      setTimeout(function () { pending = false; decorateCards(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* --- Misspolly theme helpers: whole banner clickable + collection layout switch --- */
(function () {
  'use strict';
  if (window.__misspollyHelpers) return;
  window.__misspollyHelpers = true;

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.target.closest('a, button, input, select, textarea, label, [role="button"]')) return;
    var slide = e.target.closest('.slideshow__slide');
    if (!slide) return;
    var link = slide.querySelector('a[href]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href === '#') return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) { window.open(link.href, '_blank'); return; }
    window.location.assign(link.href);
  });

  var ICON_FEW = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1"><rect x="1.5" y="1.5" width="5" height="5"/><rect x="9.5" y="1.5" width="5" height="5"/><rect x="1.5" y="9.5" width="5" height="5"/><rect x="9.5" y="9.5" width="5" height="5"/></svg>';
  var ICON_MANY = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false" fill="currentColor"><rect x="1" y="1" width="4" height="4"/><rect x="6" y="1" width="4" height="4"/><rect x="11" y="1" width="4" height="4"/><rect x="1" y="6" width="4" height="4"/><rect x="6" y="6" width="4" height="4"/><rect x="11" y="6" width="4" height="4"/><rect x="1" y="11" width="4" height="4"/><rect x="6" y="11" width="4" height="4"/><rect x="11" y="11" width="4" height="4"/></svg>';
  var KEY = 'misspolly_grid_v1';
  var mode = 'many';
  try { mode = localStorage.getItem(KEY) || 'many'; } catch (err) {}

  function isMobile() { return window.matchMedia('(max-width: 699px)').matches; }

  function applyMode() {
    var list = document.querySelector('.collection__results product-list, .collection__results .product-list');
    if (!list) return;
    var cols = mode === 'few' ? (isMobile() ? 1 : 2) : (isMobile() ? 2 : 4);
    list.style.gridTemplateColumns = 'repeat(' + cols + ', minmax(0, 1fr))';
    var sw = document.querySelector('.fl-layout-switch');
    if (sw) {
      var btns = sw.querySelectorAll('button');
      for (var i = 0; i < btns.length; i++) btns[i].classList.toggle('is-active', btns[i].getAttribute('data-fl-cols') === mode);
    }
  }

  function initSwitch() {
    var bar = document.querySelector('.collection__top-bar');
    if (!bar) return;
    if (!bar.querySelector('.fl-layout-switch')) {
      var sort = bar.querySelector('facet-sort-by');
      var host = sort ? sort.parentElement : bar;
      var wrap = document.createElement('div');
      wrap.className = 'fl-layout-switch';
      wrap.innerHTML = '<button type="button" data-fl-cols="few" aria-label="Fewer products per row">' + ICON_FEW + '</button><button type="button" data-fl-cols="many" aria-label="More products per row">' + ICON_MANY + '</button>';
      host.insertBefore(wrap, sort || null);
    }
    applyMode();
  }

  // one delegated listener: the switch is printed by snippets/collection-top-bar.liquid (or built above as a fallback)
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.fl-layout-switch button[data-fl-cols]') : null;
    if (!b) return;
    mode = b.getAttribute('data-fl-cols');
    try { localStorage.setItem(KEY, mode); } catch (err) {}
    applyMode();
  });

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(initSwitch, 150); }
  function boot() {
    initSwitch();
    var sec = document.querySelector('.shopify-section--main-collection, .shopify-section--main-search');
    if (sec && window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes.length) { schedule(); return; } }
      }).observe(sec, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(applyMode, 150); });
  document.addEventListener('shopify:section:load', schedule);
})();

/* --- Misspolly cart helpers: size chips on cards that add to cart, stepper, total in the checkout button, "You'll also love" --- */
(function () {
  'use strict';
  if (window.__misspollyCart) return;
  window.__misspollyCart = true;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var RECO_TITLE = "You'll also love";

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    var tv = window.themeVariables && window.themeVariables.settings;
    var fmt = (tv && tv.moneyFormat) || (window.MISSPOLLY_WISHLIST && window.MISSPOLLY_WISHLIST.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    if (/amount_no_decimals/.test(fmt)) amount = String(Math.round(cents / 100));
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  /* ---------- add to cart through the theme's own event flow (drawer refresh + open) ---------- */
  function addToCart(variantId, quantity) {
    var sections = ['variant-added', 'misspolly-cart-json'];   // the cart comes back with the add (no second /cart.js)
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var fd = new FormData();
    fd.set('id', String(variantId));
    fd.set('quantity', String(quantity || 1));
    fd.set('sections', sections.join(','));
    fd.set('sections_url', root + 'variants/' + variantId);
    return fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: res.json.description || res.json.message || 'Error' } }));
          throw new Error(res.json.description || 'add failed');
        }
        var bundled = null;
        try { bundled = JSON.parse(new DOMParser().parseFromString(res.json.sections['misspolly-cart-json'], 'text/html').querySelector('script').textContent); } catch (e) { bundled = null; }
        return (bundled && bundled.item_count != null ? Promise.resolve(bundled) : fetch(root + 'cart.js').then(function (r) { return r.json(); })).then(function (cart) {
          cart.sections = res.json.sections;
          document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: res.json.items ? res.json.items : [res.json], cart: cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
          return cart;
        });
      });
  }

  /* ---------- size chips on product cards ----------
     04/10/2026: the chips are printed by snippets/product-card.liquid. They used to be built here after one
     /products/<handle>.js request per card (measured: 24 requests / 72 KB on /collections/dresses, 8 / 19 KB on the
     home page, 4 at a time during load) and the late insertion moved the grid (layout shift 0.0122 on every run).
     Only the click lives here now. loadProduct stays: the cart recommendations use it. */
  var productCache = {};
  function loadProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    return productCache[handle];
  }
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.fl-size');
    if (!chip) return;
    e.preventDefault(); e.stopPropagation();
    if (chip.classList.contains('is-disabled') || chip.getAttribute('aria-busy') === 'true') return;
    chip.setAttribute('aria-busy', 'true');
    addToCart(chip.getAttribute('data-variant-id'), 1).catch(function () {}).then(function () { chip.removeAttribute('aria-busy'); });
  }, true);

  /* ---------- "Wear it with" row on the product page (04/10/2026, owner): pick a size, then ADD TO CART ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var size = t.closest('.mp-wiw__size');
    if (size) {
      e.preventDefault();
      if (size.getAttribute('aria-disabled') === 'true') return;
      var card = size.closest('.mp-wiw__card');
      card.querySelectorAll('.mp-wiw__size').forEach(function (b) { b.setAttribute('aria-pressed', b === size ? 'true' : 'false'); });
      var btn = card.querySelector('.mp-wiw__add');
      if (btn) { btn.setAttribute('data-variant-id', size.getAttribute('data-variant-id')); btn.disabled = false; btn.textContent = btn.getAttribute('data-label') || 'Add to cart'; }
      return;
    }
    var add = t.closest('.mp-wiw__add');
    if (add) {
      e.preventDefault();
      var id = add.getAttribute('data-variant-id');
      if (!id || add.disabled || add.getAttribute('aria-busy') === 'true') return;
      add.setAttribute('aria-busy', 'true');
      addToCart(id, 1).catch(function () {}).then(function () { add.removeAttribute('aria-busy'); });
      return;
    }
    var arrow = t.closest('[data-mp-wiw-dir]');
    if (arrow) {
      var track = arrow.closest('.mp-wiw') && arrow.closest('.mp-wiw').querySelector('.mp-wiw__grid--track');
      if (track) track.scrollBy({ left: Number(arrow.getAttribute('data-mp-wiw-dir')) * track.clientWidth * 0.9, behavior: 'smooth' });
    }
  });

  /* ---------- cart drawer: stepper, total inside the checkout button, recommendations ---------- */
  var lastReco = { key: '', html: '' };
  var recoCache = {};

  function stepQty(input, delta) {
    var min = parseInt(input.min || '1', 10) || 1;
    var max = parseInt(input.max || '0', 10);
    var v = (parseInt(input.value, 10) || 0) + delta;
    if (v < min) v = min;
    if (max && v > max) v = max;
    if (String(v) === input.value) return;
    input.value = String(v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  /* 04/10/2026 (owner): every card has "+ Add" and shows the compare-at price
 struck through. A one-size piece goes straight to the cart; a piece with sizes opens its sizes over the photo
 first (sold-out sizes crossed out). p = { id, handle, title, img, price, compare, v: [[variantId, title, available]] } */
  function cardHTML(p, i) {   // i < 3: the cards on screen when the drawer opens load with it, not after it
    var img = p.img || '';
    if (img && !/[?&]width=/.test(img)) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
    var vs = p.v || [], sizes = '', cta;
    if (vs.length > 1) {
      sizes = '<div class="fl-cart-reco__sizes"><div class="fl-cart-reco__chips" role="group" aria-label="Size for ' + esc(p.title) + '">' + vs.map(function (v) {
        return '<button type="button" class="fl-cart-reco__size" data-reco-add="' + esc(v[0]) + '"' + (v[2] ? '' : ' disabled title="Sold out"') + '>' + esc(v[1]) + '</button>';
      }).join('') + '</div></div>';
      cta = '<button type="button" class="fl-cart-reco__add" data-reco-pick aria-expanded="false">+ Add</button>';
    } else {
      cta = '<button type="button" class="fl-cart-reco__add" data-reco-add="' + esc(vs[0] ? vs[0][0] : '') + '">+ Add</button>';
    }
    return '<div class="fl-cart-reco__card"><a class="fl-cart-reco__link" href="' + root + 'products/' + esc(p.handle) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="300" height="450" loading="' + (i < 3 ? 'eager' : 'lazy') + '">' : '') + '<span class="fl-cart-reco__title">' + esc(p.title) + '</span><span class="fl-cart-reco__price"><span>' + esc(money(p.price)) + '</span>' + (p.compare > p.price ? '<s>' + esc(money(p.compare)) + '</s>' : '') + '</span></a>' + sizes + cta + '</div>';
  }
  function ensureRecoBlocks(drawer) {
    var inner = drawer.querySelector('.cart-drawer__inner');
    var panel = document.querySelector('.fl-cart-reco-panel');
    if (!panel && !lastReco.html) return; // nothing to show yet: do not append to <body> on every page load
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'fl-cart-reco-panel';
      panel.innerHTML = '<div class="fl-cart-reco-panel__head">' + esc(RECO_TITLE) + '</div><div class="fl-cart-reco-panel__list"></div>';
      document.body.appendChild(panel);
    }
    if (inner && lastReco.html) {
      var block = inner.querySelector('.fl-cart-reco');
      if (!block) {
        block = document.createElement('div');
        block.className = 'fl-cart-reco';
        block.innerHTML = '<div class="fl-cart-reco__head"><span>' + esc(RECO_TITLE) + '</span><button type="button" class="fl-cart-reco__toggle" aria-label="Show or hide recommendations">−</button></div><div class="fl-cart-reco__list"></div>';
        block.querySelector('.fl-cart-reco__toggle').addEventListener('click', function () {
          block.classList.toggle('is-collapsed');
          this.textContent = block.classList.contains('is-collapsed') ? '+' : '−';
        });
        inner.appendChild(block);
      }
      if (block.getAttribute('data-key') !== lastReco.key) { block.setAttribute('data-key', lastReco.key); block.querySelector('.fl-cart-reco__list').innerHTML = lastReco.html; }
    }
    if (panel.getAttribute('data-key') !== lastReco.key) { panel.setAttribute('data-key', lastReco.key); panel.querySelector('.fl-cart-reco-panel__list').innerHTML = lastReco.html; }
    syncPanel(drawer);
  }
  function syncPanel(drawer) {
    var panel = document.querySelector('.fl-cart-reco-panel');
    if (!panel) return;
    var open = drawer && drawer.hasAttribute('open') && !!drawer.querySelector('.cart-drawer__inner') && !!lastReco.html;
    panel.classList.toggle('is-open', open);
  }
  /* "You'll also love" = dresses and the other pieces of the cart, mixed in proportion and interleaved
     (owner, 05/10/2026; a second dress raises the order value more than an accessory, so dresses lead):
     - 6 cards. The other pieces get round(6 x non-dress lines / all lines) cards, never more than 3:
       only dresses -> 6 dresses; 1 dress + 1 accessory -> 3 + 3; 2 dresses + 1 accessory -> 4 + 2;
       only accessories -> 3 best-selling dresses + 3 accessories. Interleaved D, A, D, A... evenly.
     - dresses follow the oldest DRESS line (playsuits count as mini dresses): maxi -> maxi dresses, midi -> midi
       dresses, mini or playsuit -> mini dresses, bridal, bridesmaid; then Shopify's related products, best-selling
       dresses, all dresses. The other cards follow the oldest non-dress line: its category, then Shopify's related.
     - every card is checked with isDress(), so a list that also holds other pieces never puts one on the wrong side.
     Weight: at most one more ~10 KB list than a dresses-only row, and only when the cart holds a non-dress. */
  var STYLE_RULES = [
    { re: /\bmaxi\b/i, collection: 'maxi-dresses' },
    { re: /\bmidi\b/i, collection: 'midi-dresses' },
    { re: /\b(mini|playsuit)\b/i, collection: 'mini-dresses' },
    { re: /\b(bridal|bride|wedding dress)\b/i, collection: 'bridal' },
    { re: /\bbridesmaid\b/i, collection: 'bridesmaid' }
  ];
  var OTHER_RULES = [
    { re: /\b(bikini|swimsuit|swim)\b/i, collection: 'swimwear' },
    { re: /\bjumpsuit\b/i, collection: 'jumpsuits-playsuits' },
    { re: /\bearrings?\b/i, collection: 'earrings' },
    { re: /\b(gloves?|scarf|scarves|bag|belt|necklace|cuff|bracelet|veil|accessor)/i, collection: 'accessories' },
    { re: /\bskirts?\b/i, collection: 'skirts' },
    { re: /\b(top|tops|bodysuit|corset)\b/i, collection: 'tops' },
    { re: /\b(pants?|trousers?|shorts?)\b/i, collection: 'bottoms' },
    { re: /\b(coat|jacket|blazer)\b/i, collection: 'coats-jackets' },
    { re: /\b(set|sets|two[- ]piece|co[- ]ord)\b/i, collection: 'sets' }
  ];
  function isDress(title) { return /\b(dress|gown|playsuit)\b/i.test(title || '') && !/\bdressing gown\b/i.test(title || ''); }
  function styleCollection(item, product, rules) {
    var hay = [item.product_title || item.title || '', item.product_type || '', product && product.type || '', product && product.tags ? product.tags.join(' ') : ''].join(' ');
    for (var i = 0; i < rules.length; i++) { if (rules[i].re.test(hay)) return rules[i].collection; }
    return null;
  }
  /* where the cards come from, in this order, until there are RECO_MAX:
     1) the collection of the piece's style, through templates/collection.mp-reco.liquid (24 available products,
        ~0.4 KB each, prices in the shopper's currency; products.json was ~9 KB a product, measured 04/10/2026)
     2) Shopify's related products   3) best-selling dresses   4) all dresses (only dresses are kept, see isDress).
     Each list is asked once per page and kept, so adding a recommendation refills the row without a new request. */
  var RECO_MAX = 6;
  var listCache = {};
  function fromView(col) {
    var key = 'v:' + col;
    return listCache[key] || (listCache[key] = fetch(root + 'collections/' + col + '?view=mp-reco').then(function (r) { return r.ok ? r.text() : '[]'; }).then(function (t) {
      try { var a = JSON.parse(t); return Array.isArray(a) ? a : []; } catch (e) { return []; }   // not this theme's template: HTML comes back
    }).catch(function () { return []; }));
  }
  function normProductJs(p) {   // /recommendations/products.json uses the /products/<handle>.js shape (money in cents)
    var vs = p.variants || [], fv = vs.filter(function (v) { return v.available; })[0] || vs[0] || {};
    return { id: p.id, handle: p.handle, title: p.title, img: p.featured_image || '', price: fv.price != null ? fv.price : p.price, compare: fv.compare_at_price || 0, available: p.available !== false,
      v: vs.map(function (v) { return [v.id, v.title, v.available !== false]; }) };
  }
  function related(productId) {
    var key = 'r:' + productId;
    return listCache[key] || (listCache[key] = fetch(root + 'recommendations/products.json?product_id=' + productId + '&limit=10&intent=related').then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) { return (j.products || []).map(normProductJs); }).catch(function () { return []; }));
  }
  var recoSeq = 0;
  function refreshReco(drawer, known) {   // known = the cart carried by the cart:change event (no second /cart.js)
    var seq = ++recoSeq;
    (known ? Promise.resolve(known) : fetch(root + 'cart.js').then(function (r) { return r.json(); })).then(function (cart) {
      if (seq !== recoSeq) return;
      if (!cart.items || !cart.items.length) { lastReco = { key: 'empty', html: '' }; syncPanel(drawer); return; }
      /* the row follows the piece she came for: the OLDEST line (Shopify lists the newest first). Adding a
 recommendation then only takes that card out and the next one comes in at the end, so the row keeps 6
 (owner, 04/10/2026). It used to follow the newest line: adding a pair of
 earrings from the row turned the whole row into earrings. Since 05/10/2026: the oldest DRESS line drives the
 dresses and the oldest non-dress line drives the other cards (rule above). */
      var dressLines = cart.items.filter(function (i) { return isDress(i.product_title || i.title); });
      var otherLines = cart.items.filter(function (i) { return !isDress(i.product_title || i.title); });
      var dItem = dressLines.length ? dressLines[dressLines.length - 1] : null;
      var oItem = otherLines.length ? otherLines[otherLines.length - 1] : null;
      var nOther = oItem ? Math.min(Math.floor(RECO_MAX / 2), Math.round(RECO_MAX * otherLines.length / cart.items.length)) : 0;
      var inCart = cart.items.map(function (i) { return i.product_id; });
      var key = (dItem ? dItem.product_id : '-') + '/' + (oItem ? oItem.product_id : '-') + '/' + nOther + ':' + inCart.join(',');
      if (key === lastReco.key) { ensureRecoBlocks(drawer); return; }
      Promise.all([dItem ? loadProduct(dItem.handle) : null, oItem ? loadProduct(oItem.handle) : null]).then(function (ps) {
        var seen = {};
        var collect = function (steps, want, max) {   // walks the lists in order until there are max cards of the wanted side
          var got = [];
          var take = function (list) {
            for (var i = 0; i < list.length && got.length < max; i++) {
              var x = list[i];
              if (!x || x.available === false || isDress(x.title) !== want || seen[x.id] || inCart.indexOf(x.id) !== -1) continue;
              seen[x.id] = true; got.push(x);
            }
          };
          var run = function (i) { return got.length >= max || i >= steps.length ? got : steps[i]().then(function (list) { take(list); return run(i + 1); }); };
          return Promise.resolve(run(0));   // always a promise, also when max is 0 (a cart with only dresses)
        };
        var dCol = dItem ? styleCollection(dItem, ps[0], STYLE_RULES) : null, oCol = oItem ? styleCollection(oItem, ps[1], OTHER_RULES) : null;
        var dSteps = [dCol ? function () { return fromView(dCol); } : null, dItem ? function () { return related(dItem.product_id); } : null,
          function () { return fromView('best-sellers'); }, function () { return fromView('dresses'); }].filter(Boolean);
        var oSteps = [oCol ? function () { return fromView(oCol); } : null, oItem ? function () { return related(oItem.product_id); } : null].filter(Boolean);
        // the other side first (it is the smaller one), then dresses fill everything it could not
        return collect(oSteps, false, nOther).then(function (others) {
          return collect(dSteps, true, RECO_MAX - others.length).then(function (ds) {
            var out = [], a = 0, b = 0;   // interleave evenly: the side that is "behind" in its share goes next, dresses first on a tie
            while (out.length < ds.length + others.length) {
              if (b >= others.length || (a < ds.length && a / ds.length <= b / others.length)) out.push(ds[a++]); else out.push(others[b++]);
            }
            return out;
          });
        });
      }).then(function (list) {
        if (seq !== recoSeq) return;   // an older answer arriving late must not overwrite a newer cart
        lastReco = { key: key, html: list.map(cardHTML).join('') };
        ensureRecoBlocks(drawer);
      });
    }).catch(function () {});
  }

  /* "+ Add" on the recommendations (inline row in the drawer and desktop side panel) */
  function closePick(except) {
    document.querySelectorAll('.fl-cart-reco__card.is-picking').forEach(function (c) {
      if (c === except) return;
      c.classList.remove('is-picking');
      var b = c.querySelector('[data-reco-pick]'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function onRecoClick(e) {
    var t = e.target; if (!t || !t.closest) return;
    var pick = t.closest('[data-reco-pick]'), add = !pick && t.closest('[data-reco-add]');
    if (!pick && !add) return;
    e.preventDefault();
    if (pick) {
      var card = pick.closest('.fl-cart-reco__card'), open = !card.classList.contains('is-picking');
      closePick(card);
      card.classList.toggle('is-picking', open);
      pick.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var id = add.getAttribute('data-reco-add');
    if (!id || add.disabled || add.getAttribute('aria-busy') === 'true') return;
    add.setAttribute('aria-busy', 'true');
    addToCart(id, 1).catch(function () {}).then(function () { add.removeAttribute('aria-busy'); });
  }
  /* the desktop panel sits outside the drawer, and the drawer closes on any press outside it (focus trap, touchend
     check). A press on the panel's buttons stays with the panel; its links still close the drawer and navigate. */
  ['mousedown', 'touchstart', 'click'].forEach(function (type) {
    window.addEventListener(type, function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('.fl-cart-reco-panel') || !t.closest('button')) return;
      e.stopPropagation();
      if (type === 'mousedown') e.preventDefault();   // keeps the focus inside the drawer
      if (type === 'click') onRecoClick(e);
    }, { capture: true, passive: type === 'touchstart' });
  });
  document.addEventListener('click', function (e) { if (!(e.target && e.target.closest && e.target.closest('.fl-cart-reco-panel'))) onRecoClick(e); });
  /* first piece of the cart, added on its product page: its recommendations start loading while /cart/add.js is still
     running (0.7-0.8 s on 4G), so the row is ready when the drawer opens (it used to land after it, measured 04/10/2026).
     With items already in the cart the row follows the oldest one, which the idle warm-up has already loaded. */
  document.addEventListener('submit', function (e) {
    var f = e.target, m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m || !f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '') || cartCount() > 0) return;
    loadProduct(decodeURIComponent(m[1])).then(function (p) {
      if (!p) return;
      var d = isDress(p.title), col = styleCollection({ product_title: p.title, product_type: p.type }, p, d ? STYLE_RULES : OTHER_RULES);
      if (col) fromView(col); else related(p.id);
      if (!d) fromView('best-sellers');   // a first piece that is not a dress: half the row will be best-selling dresses
    });
  }, true);
  function decorateDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    drawer.querySelectorAll('.line-item__media:not([data-fl-sizes-img])').forEach(function (img) { img.setAttribute('data-fl-sizes-img', '1'); img.sizes = '(max-width: 699px) 74px, 120px'; });
    drawer.querySelectorAll('line-item-quantity input.quantity-input:not([data-fl-step])').forEach(function (input) {
      input.setAttribute('data-fl-step', '1');
      var wrap = document.createElement('div'); wrap.className = 'fl-qty';
      var minus = document.createElement('button'); minus.type = 'button'; minus.className = 'fl-qty__btn'; minus.innerHTML = '<svg viewBox="0 0 16 2" aria-hidden="true" focusable="false"><path d="M1,1 L15,1" stroke="currentColor" fill="none" stroke-linecap="square"></path></svg>'; minus.setAttribute('aria-label', 'Decrease quantity');
      var plus = document.createElement('button'); plus.type = 'button'; plus.className = 'fl-qty__btn'; plus.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><g stroke="currentColor" fill="none" stroke-linecap="square"><path d="M8,1 L8,15"></path><path d="M1,8 L15,8"></path></g></svg>'; plus.setAttribute('aria-label', 'Increase quantity');
      input.parentNode.insertBefore(wrap, input);
      wrap.appendChild(minus); wrap.appendChild(input); wrap.appendChild(plus);
      minus.addEventListener('click', function () { stepQty(input, -1); });
      plus.addEventListener('click', function () { stepQty(input, 1); });
    });
    var totalRow = drawer.querySelector('[slot="footer"] .h-stack.justify-between .h5:last-child');
    var btn = drawer.querySelector('[slot="footer"] button[name="checkout"]');
    if (btn && totalRow) {
      var host = btn.querySelector('.text-with-icon') || btn;
      var span = host.querySelector('.fl-checkout-total');
      if (!span) { span = document.createElement('span'); span.className = 'fl-checkout-total'; host.appendChild(span); }
      var t = totalRow.textContent.trim();
      if (span.textContent !== t) span.textContent = t;
    }
    ensureRecoBlocks(drawer);
  }

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(decorateDrawer, 120); }
  function cartCount() {
    var el = document.querySelector('cart-count');
    var n = el ? parseInt(el.textContent, 10) : NaN;
    return isNaN(n) ? -1 : n; // -1 = unknown
  }
  function boot() {
    decorateDrawer();
    var drawer = document.getElementById('cart-drawer');
    if (drawer) {
      /* was: refreshReco(drawer) right here on EVERY page -> /cart.js every time (the theme already asks it), and with
         items in the cart also /products/<item>.js + /collections/<style>/products.json?limit=30 (268 KB of JSON)
         + /recommendations (38 KB), for a drawer most visitors never open (measured 04/10 on the draft).
         Now: empty cart -> nothing; cart with items -> after load, when the main thread is idle; and as soon as the
         shopper reaches for the cart icon. Drawer opening and cart:change keep refreshing exactly as before. */
      var warmedAt = 0;
      var warm = function () { if (warmedAt) return; warmedAt = Date.now(); refreshReco(drawer); };
      if (cartCount() !== 0) {
        var later = function () { if (window.requestIdleCallback) requestIdleCallback(warm, { timeout: 4000 }); else setTimeout(warm, 1500); };
        if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
      }
      var intent = function (e) { var t = e.target; if (t && t.closest && t.closest('[aria-controls="cart-drawer"], a[href$="/cart"]')) warm(); };
      document.addEventListener('pointerdown', intent, { passive: true, capture: true });
      document.addEventListener('touchstart', intent, { passive: true, capture: true });
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          // the icon tap already warmed it a moment ago: do not ask /cart.js twice for the same opening
          if (muts[i].type === 'attributes') { syncPanel(drawer); if (drawer.hasAttribute('open') && Date.now() - warmedAt > 1500) drawer.addEventListener('dialog:after-show', function () { refreshReco(drawer); }, { once: true }); continue; }
          if (muts[i].addedNodes.length) {
            /* the theme rebuilds the drawer after every add/change and the row went with it: it came back 120 ms later
               (debounce), a visible blink and jump (measured 04/10/2026). Observer callbacks run before the next paint,
               so putting the row back here keeps it on screen; the rest of the decoration stays debounced. */
            if (lastReco.html && drawer.hasAttribute('open') && !drawer.querySelector('.cart-drawer__inner > .fl-cart-reco')) ensureRecoBlocks(drawer);
            schedule();
          }
        }
      }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    }
    document.documentElement.addEventListener('cart:change', function (e) { var d = document.getElementById('cart-drawer'), c = e && e.detail && e.detail.cart; if (d) { if (c && c.items) warmedAt = Date.now(); setTimeout(function () { refreshReco(d, c && c.items ? c : null); }, 0); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* --- Misspolly perf helpers: hidden hero slides download after first paint; hover-only secondary card images --- */
(function () {
  'use strict';
  if (window.__misspollyPerf) return;
  window.__misspollyPerf = true;
  function restore(img) {
    if (!img || img.getAttribute('data-fl-restored')) return;
    img.setAttribute('data-fl-restored', '1');
    var pic = img.parentElement && img.parentElement.tagName === 'PICTURE' ? img.parentElement : null;
    if (pic) pic.querySelectorAll('source[data-srcset]').forEach(function (s) { s.setAttribute('srcset', s.getAttribute('data-srcset')); });
    var ss = img.getAttribute('data-srcset'); var s = img.getAttribute('data-src');
    if (ss) img.setAttribute('srcset', ss);
    if (s) img.setAttribute('src', s);
  }
  /* hero (first section): hidden slides come 2 s after load, on first interaction, or when selected.
     slideshows below the fold: hidden slides come only when the section is near the viewport or when selected. */
  function restoreHeroSlides() { document.querySelectorAll('img.fl-defer--hero').forEach(restore); }
  if (window.MutationObserver) {
    var slideObs = new MutationObserver(function (muts) {
      muts.forEach(function (m) { var slide = m.target; if (slide.classList && slide.classList.contains('is-selected')) slide.querySelectorAll('img.fl-defer').forEach(restore); });
    });
    document.querySelectorAll('.slideshow__slide').forEach(function (s) { slideObs.observe(s, { attributes: true, attributeFilter: ['class', 'aria-hidden'] }); });
  }
  ['pointerdown', 'keydown', 'touchstart', 'wheel'].forEach(function (ev) { window.addEventListener(ev, restoreHeroSlides, { once: true, passive: true }); });
  if (document.readyState === 'complete') setTimeout(restoreHeroSlides, 2000);
  else window.addEventListener('load', function () { setTimeout(restoreHeroSlides, 2000); });
  /* 04/10/2026 (published theme, PageSpeed mobile 71, LCP 5.9 s): sections below the hero (now every slide and the
     collection tiles below the first section) wait until the hero photo has loaded, so on a slow phone the LCP image
     gets the connection to itself (it shared it with ~250 KB of images further down). Then they come in near the
     viewport as before (800 px ahead). No hero photo on the page, or it fails: they start at once / after 4 s at most. */
  function afterHero(cb) {
    var done = false, go = function () { if (!done) { done = true; cb(); } };
    var hero = document.querySelector('main img[fetchpriority="high"]');
    if (!hero || (hero.complete && hero.naturalWidth)) return go();
    hero.addEventListener('load', go, { once: true });
    hero.addEventListener('error', go, { once: true });
    setTimeout(go, 4000);
  }
  afterHero(function () {
    if (window.IntersectionObserver) {
      var belowObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (!en.isIntersecting) return; belowObs.unobserve(en.target); en.target.querySelectorAll('img.fl-defer--below').forEach(restore); });
      }, { rootMargin: '800px 0px' });
      document.querySelectorAll('img.fl-defer--below').forEach(function (img) { var sec = img.closest('.shopify-section') || img; belowObs.observe(sec); });
    } else {
      document.querySelectorAll('img.fl-defer--below').forEach(restore);
    }
  });
  /* secondary (hover) image of product cards: only downloads when a mouse pointer enters the card; touch never downloads it */
  document.addEventListener('pointerenter', function (e) {
    if (e.pointerType === 'touch') return;
    var t = e.target; if (!t || !t.closest) return;
    var card = t.closest('product-card'); if (!card) return;
    card.querySelectorAll('img.product-card__image--secondary[data-src], img.product-card__image--secondary[data-srcset]').forEach(restore);
  }, true);
})();

/* --- Misspolly: phone / tablet menu (snippets/misspolly-nav-drawer.liquid, styles in misspolly-store.css).
 drawer slides in from the left in .5s, overlay fades to .5, content follows .25s later,
 social bar rises .45s later; every level is an accordion (+ / -) that animates its height in .35s; nothing reloads.
 The burger points here with aria-controls="mp-menu". Escape, the X and the overlay close it; focus stays inside while
 open and goes back to the burger on close. --- */
(function () {
  'use strict';
  var m = document.getElementById('mp-menu');
  if (!m || window.__mpMenu) return;
  window.__mpMenu = true;
  if (m.parentNode !== document.body) document.body.appendChild(m);   // out of the sticky header: fixed to the screen
  var root = document.documentElement, back = null, hideT = 0;

  function burgers(v) {
    document.querySelectorAll('[aria-controls="mp-menu"]').forEach(function (b) { b.setAttribute('aria-expanded', v ? 'true' : 'false'); });
  }
  function open(btn) {
    clearTimeout(hideT);
    back = btn || document.activeElement;
    m.hidden = false;
    m.classList.remove('is-closing');
    void m.offsetWidth;                                   // start from the closed state so the slide runs
    m.classList.add('is-open');
    root.classList.add('mp-menu-lock');
    burgers(true);
    var x = m.querySelector('.mp-menu__x');
    if (x) try { x.focus({ preventScroll: true }); } catch (e) {}
  }
  function close(now) {
    if (m.hidden) return;
    clearTimeout(hideT);
    m.classList.add('is-closing');
    m.classList.remove('is-open');
    root.classList.remove('mp-menu-lock');
    burgers(false);
    var end = function () { m.hidden = true; m.classList.remove('is-closing'); };
    if (now) end(); else hideT = setTimeout(end, 500);
    if (back && back.focus && !now) try { back.focus({ preventScroll: true }); } catch (e) {}
  }

  // accordion: height from 0 to the measured height and back, then auto (nested lists keep working)
  function settle(p, fn) {
    var tok = p.__mpTok = (p.__mpTok || 0) + 1, done = false;
    function f(e) {
      if (e && e.target !== p) return;
      if (done || tok !== p.__mpTok) return;
      done = true; p.removeEventListener('transitionend', f); fn();
    }
    p.addEventListener('transitionend', f);
    setTimeout(f, 420);                                   // no transitionend with reduced motion
  }
  function expand(p) {
    p.style.visibility = 'visible';
    p.style.height = '0px';
    void p.offsetHeight;
    p.style.height = p.scrollHeight + 'px';
    settle(p, function () { p.classList.add('is-open'); p.style.height = ''; p.style.visibility = ''; });
  }
  function collapse(p) {
    p.style.height = p.scrollHeight + 'px';
    p.style.visibility = 'visible';
    p.classList.remove('is-open');
    void p.offsetHeight;
    p.style.height = '0px';
    settle(p, function () { p.style.height = ''; p.style.visibility = ''; });
  }
  function toggle(btn) {
    var p = document.getElementById(btn.getAttribute('aria-controls'));
    if (!p) return;
    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    if (isOpen) collapse(p); else expand(p);
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var burger = t.closest('[aria-controls="mp-menu"]');
    if (burger) { e.preventDefault(); if (m.classList.contains('is-open')) close(); else open(burger); return; }
    if (!m.contains(t)) return;
    if (t.closest('[data-mp-menu-close]')) { e.preventDefault(); close(); return; }
    var acc = t.closest('[data-mp-acc]');
    if (acc) { e.preventDefault(); toggle(acc); }
  });
  document.addEventListener('keydown', function (e) {
    if (!m.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(m.querySelectorAll('a[href], button:not([disabled])'), function (el) {
      return el.getClientRects().length && !el.closest('.mp-menu__inner:not(.is-open)');
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !m.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !m.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) close(true); });   // back button: never come back to an open menu
  window.addEventListener('resize', function () { if (window.innerWidth >= 1150 && m.classList.contains('mp-menu--lg-hidden')) close(true); });
})();


/* --- Search bar (snippets/misspolly-search-bar.liquid, sections/misspolly-search-suggest.liquid), 04/10/2026.
 Phone (< 700 px): the magnifier toggles a thin bar under the header and clears it; no autofocus, the panel opens when
 the field gets focus; a tap outside closes only the panel. Collection and search pages keep the bar visible; the home
 page shows it after 20 px of scroll (header setting). Desktop: dark overlay, field focused, panel at once; Esc closes the
 panel and clears the text, a click on the overlay closes the panel, the X closes the bar. Hovering a term swaps the
 products. Data: /search/suggest?section_id=misspolly-search-suggest, 200 ms after the last key, cached per term. */
(function () {
  'use strict';
  var bar = document.getElementById('mp-search');
  if (!bar || window.__mpSearch) return;
  window.__mpSearch = true;
  var input = document.getElementById('mp-search-input'), panel = document.getElementById('mp-search-panel');
  var status = document.getElementById('mp-search-status'), form = bar.querySelector('form');
  var header = bar.closest('store-header') || bar.parentNode, root = document.documentElement;
  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('mp-search-config').textContent); } catch (e) {}
  var popular = (cfg.popular || []).map(function (s) { return String(s).trim(); }).filter(Boolean).slice(0, 6);
  var pinned = bar.hasAttribute('data-pinned'), home = bar.hasAttribute('data-home');
  var mq = window.matchMedia('(min-width: 700px)');
  var cache = {}, order = [], ctrl = null, timer = 0, hoverT = 0, overlay = null, back = null;

  function desk() { return mq.matches; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function key(q) { return q.trim().toLowerCase(); }
  function url(q) { return (cfg.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product'; }
  function isOpen() { return bar.hasAttribute('open'); }
  function shown() { return isOpen() || (pinned && !desk() && !bar.hasAttribute('data-closed')); }
  function lupas(v) {
    document.querySelectorAll('[aria-controls="mp-search"]').forEach(function (b) { b.setAttribute('aria-expanded', v ? 'true' : 'false'); });
  }
  function setOpen(v) {
    if (v === isOpen()) return;
    if (v) bar.setAttribute('open', ''); else bar.removeAttribute('open');
    lupas(v);
    try { bar.dispatchEvent(new Event('toggle')); } catch (e) {}   // the header recomputes its transparency
  }
  function overlayOn(v) {
    if (v && !overlay) {
      overlay = document.createElement('div');
      overlay.className = 'mp-search__overlay';
      document.body.appendChild(overlay);
      overlay.addEventListener('click', function () { if (!panel.hidden) closePanel(); else closeBar(); });
      void overlay.offsetWidth;
    }
    if (overlay) overlay.classList.toggle('is-on', !!v);
    root.classList.toggle('mp-search-lock', !!v);
  }

  // ---- data
  function get(q) {
    var k = key(q);
    if (cache[k]) return Promise.resolve(cache[k]);
    if (ctrl) try { ctrl.abort(); } catch (e) {}
    var c = ctrl = window.AbortController ? new AbortController() : null;
    var u = (cfg.suggest || '/search/suggest') + '?q=' + encodeURIComponent(q.trim()) + '&section_id=' + (cfg.section || 'misspolly-search-suggest') +
      '&resources%5Btype%5D=query,product&resources%5Blimit%5D=8&resources%5Blimit_scope%5D=each&resources%5Boptions%5D%5Bunavailable_products%5D=last';
    var tries = 0;
    function go() {
      return fetch(u, c ? { signal: c.signal, credentials: 'same-origin' } : { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(function (html) {
        var d = document.createElement('div');
        d.innerHTML = html;
        var sr = d.querySelector('.mp-sr');
        if (!sr) throw new Error('empty');
        cache[k] = sr; order.push(k);
        if (order.length > 30) delete cache[order.shift()];
        return sr;
      }).catch(function (e) {
        if (e && e.name === 'AbortError') throw e;
        if (tries++ < 1) return new Promise(function (ok) { setTimeout(ok, 1500); }).then(go);
        throw e;
      });
    }
    return go();
  }
  function skeleton() {
    var s = '<div class="mp-sr__body" data-mp-body><div class="mp-sr__block mp-sr__block--products"><h5 class="mp-sr__title">Product Results</h5><ul class="mp-sr__grid" role="list">';
    for (var i = 0; i < 8; i++) s += '<li class="mp-sr__card"><span class="mp-sr__img"></span></li>';
    return s + '</ul></div></div>';
  }
  // put the products / facets / "see all" of a response under the current terms
  function swapBody(sr) {
    var c = sr.cloneNode(true);
    var nb = c.querySelector('.mp-sr__body') || c.querySelector('.mp-sr__empty');
    var ob = panel.querySelector('.mp-sr__body, .mp-sr__empty');
    if (nb && ob) ob.parentNode.replaceChild(nb, ob);
    var terms = panel.querySelector('.mp-sr__block--terms');
    var os = terms && terms.querySelector('.mp-sr__see'), ns = c.querySelector('.mp-sr__see');
    if (os) os.parentNode.removeChild(os);
    if (terms && ns) terms.appendChild(ns);
  }

  // ---- render
  function renderPopular() {
    var t = popular[0];
    panel.innerHTML = '<div class="mp-sr mp-sr--popular"><div class="mp-sr__block mp-sr__block--terms"><h5 class="mp-sr__title mp-sr__title--popular">' +
      (desk() ? 'Search Suggestions' : 'Popular Searches') + '</h5><ul class="mp-sr__terms" role="list">' +
      popular.map(function (p, i) {
        return '<li><a class="mp-sr__term' + (i ? '' : ' is-active') + '" href="' + esc(url(p)) + '" data-q="' + esc(p) + '">' + esc(p) + '</a></li>';
      }).join('') + '</ul></div>' + (t ? skeleton() : '') + '</div>';
    status.textContent = 'Popular searches';
    if (!t) return;
    get(t).then(function (sr) {
      if (panel.hidden || input.value.trim() || !panel.querySelector('.mp-sr--popular')) return;
      swapBody(sr);
    }).catch(function () {});
  }
  function render(sr, q) {
    var c = sr.cloneNode(true);
    panel.innerHTML = '';
    panel.appendChild(c);
    var n = +c.getAttribute('data-products') || 0, m = c.querySelectorAll('.mp-sr__term').length;
    status.textContent = n ? (n + ' products and ' + m + ' suggestions for "' + q + '"') : ('No results found for "' + q + '". Please try another search.');
  }
  function search(q) {
    var v = q.trim();
    if (!v) { renderPopular(); return; }
    if (!panel.querySelector('.mp-sr')) panel.innerHTML = '<div class="mp-sr">' + skeleton() + '</div>';
    var slow = setTimeout(function () {
      var b = panel.querySelector('.mp-sr__block--products');
      if (b) b.setAttribute('aria-busy', 'true');
    }, 300);
    get(v).then(function (sr) {
      clearTimeout(slow);
      if (panel.hidden || input.value.trim() !== v) return;
      render(sr, v);
    }).catch(function () {
      clearTimeout(slow);
      var b = panel.querySelector('[aria-busy]');
      if (b) b.removeAttribute('aria-busy');
    });
  }

  // ---- open / close
  function openPanel() {
    if (!panel.hidden) return;
    panel.hidden = false;
    if (input.value.trim()) search(input.value); else renderPopular();
  }
  function closePanel() {
    panel.hidden = true;
    clearTimeout(timer); clearTimeout(hoverT);
  }
  function openBar() {
    input.value = '';
    bar.removeAttribute('data-closed');
    setOpen(true);
    if (!desk() && popular[0]) get(popular[0]).catch(function () {});   // warm the empty state
    if (desk()) {
      back = document.activeElement;
      overlayOn(true);
      panel.hidden = true;
      openPanel();
      setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, 160);
    }
  }
  function closeBar() {
    closePanel();
    input.value = '';
    setOpen(false);
    if (pinned) bar.setAttribute('data-closed', '');
    overlayOn(false);
    if (document.activeElement === input) input.blur();
    if (desk() && back && back.focus) try { back.focus({ preventScroll: true }); } catch (e) {}
    back = null;
  }

  // ---- events
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    if (t.closest('[aria-controls="mp-search"]')) {
      e.preventDefault(); e.stopPropagation();
      if (shown()) closeBar(); else openBar();
      return;
    }
    if (t.closest('[data-mp-search-close]')) { e.preventDefault(); closeBar(); }
  }, true);
  document.addEventListener('pointerdown', function (e) {
    if (panel.hidden) return;
    var t = e.target;
    if (bar.contains(t) || t === overlay || (t.closest && t.closest('[aria-controls="mp-search"]'))) return;
    closePanel();
    if (document.activeElement === input) input.blur();
  });
  input.addEventListener('focus', function () {
    if (!shown()) { bar.removeAttribute('data-closed'); setOpen(true); }
    openPanel();
  });
  input.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      panel.hidden = false;
      if (input.value.trim()) search(input.value); else renderPopular();
    }, 200);
  });
  form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });
  bar.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      if (desk()) {
        if (!panel.hidden) { closePanel(); input.value = ''; input.focus(); } else closeBar();
      } else { closePanel(); input.focus(); }
      return;
    }
    if (e.key === 'ArrowDown' && e.target === input && !panel.hidden) {
      var a = panel.querySelector('a[href]');
      if (a) { e.preventDefault(); a.focus(); }
      return;
    }
    if (e.key === 'Tab' && desk() && overlay && overlay.classList.contains('is-on')) {   // keep focus inside while the page is dimmed
      var f = Array.prototype.filter.call(bar.querySelectorAll('input:not([type="hidden"]), button, a[href]'), function (el) { return el.getClientRects().length; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  panel.addEventListener('mouseover', function (e) {
    if (!desk()) return;
    var a = e.target.closest && e.target.closest('.mp-sr__term');
    if (!a || a.classList.contains('is-active')) return;
    clearTimeout(hoverT);
    hoverT = setTimeout(function () {
      var q = a.getAttribute('data-q');
      if (!q || !a.isConnected) return;
      panel.querySelectorAll('.mp-sr__term.is-active').forEach(function (x) { x.classList.remove('is-active'); });
      a.classList.add('is-active');
      get(q).then(function (sr) { if (a.isConnected && a.classList.contains('is-active')) swapBody(sr); }).catch(function () {});
    }, 150);
  });
  panel.addEventListener('mouseout', function () { clearTimeout(hoverT); });

  // collection / search pages on the phone: the bar stays under the header
  function pin() {
    if (!pinned) return;
    if (!desk() && !bar.hasAttribute('data-closed')) setOpen(true);
    if (desk() && isOpen() && !(overlay && overlay.classList.contains('is-on'))) setOpen(false);
  }
  // home page on the phone: the bar shows after 20 px of scroll and the header stays white meanwhile
  var ticking = false;
  function onScroll() {
    ticking = false;
    if (!home || desk()) return;
    var y = window.scrollY || window.pageYOffset;
    if (y >= 20) {
      header.classList.add('mp-search-solid');
      if (!isOpen()) setOpen(true);
    } else {
      if (isOpen() && document.activeElement !== input && !input.value.trim()) {
        closePanel();
        if ('_hasSwitchedToSticky' in header) header._hasSwitchedToSticky = false;   // no slide-out of the header on the way back
        setOpen(false);
      }
      if (!isOpen()) header.classList.remove('mp-search-solid');
    }
  }
  if (home) {
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
  }
  pin();
  var onMq = function () {
    closePanel();
    overlayOn(false);
    if (!desk() && !pinned && !(home && (window.scrollY || 0) >= 20)) setOpen(false);
    if (desk() && home) header.classList.remove('mp-search-solid');
    pin(); onScroll();
  };
  if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    closePanel(); overlayOn(false);
    if (!pinned) { input.value = ''; setOpen(false); }
    pin(); onScroll();
  });
})();

/* --- "View more" on the search results page (snippets/misspolly-view-more.liquid): loads the next page of the same
 search into the grid, keeps "Showing 1 - N", moves the progress bar and updates the address with page=N. --- */
(function () {
  'use strict';
  if (window.__mpMore) return;
  window.__mpMore = true;
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-mp-more-btn]') : null;
    if (!btn) return;
    var sec = btn.closest('.shopify-section'), list = sec && sec.querySelector('.product-list');
    if (!sec || !list) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var href = btn.getAttribute('href'), id = sec.id.replace('shopify-section-', '');
    fetch(href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      var d = document.createElement('div');
      d.innerHTML = html;
      var have = {};
      list.querySelectorAll('product-card a[href*="/products/"]').forEach(function (a) { have[a.pathname] = 1; });
      var firstNew = null;
      var cards = d.querySelectorAll('.product-list > *');
      Array.prototype.forEach.call(cards, function (card) {
        var a = card.querySelector('a[href*="/products/"]');
        if (a && have[a.pathname]) return;
        if (a) have[a.pathname] = 1;
        list.appendChild(card);
        if (!firstNew) firstNew = card;
      });
      var cur = sec.querySelector('[data-mp-more]'), nxt = d.querySelector('[data-mp-more]');
      if (cur && nxt) {
        var from = cur.getAttribute('data-from'), f = nxt.querySelector('[data-mp-more-from]');
        if (f && from) f.textContent = from;
        nxt.setAttribute('data-from', from || nxt.getAttribute('data-from'));
        var shown = list.querySelectorAll('product-card').length || list.children.length;   // cards really in the grid (duplicates are skipped)
        var total = +nxt.getAttribute('data-total') || 0, to = (+from || 1) + shown - 1, span = nxt.querySelector('.mp-more__bar span'), t = nxt.querySelector('[data-mp-more-to]');
        if (t) t.textContent = to;
        nxt.setAttribute('data-to', to);
        if (span && total) span.style.width = Math.min(100, shown / total * 100) + '%';
        cur.parentNode.replaceChild(nxt, cur);
      } else if (cur) {
        var b = cur.querySelector('[data-mp-more-btn]');
        if (b) b.parentNode.removeChild(b);
      }
      try { history.replaceState(history.state, '', href); } catch (err) {}
      if (firstNew) {
        var link = firstNew.querySelector('a[href]');
        if (link) try { link.focus({ preventScroll: true }); } catch (err) {}
      }
    }).catch(function () {
      btn.removeAttribute('aria-busy');
      window.location.href = btn.getAttribute('href');
    });
  });
})();
